/* eslint-disable */
export default {
  onSearching: 'Laden...',
  noContacts: 'Keine Datensätze gefunden.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
